import type { FunctionComponent } from "react";

import { useTopBannerAdSlot } from "scmp-app/components/advertisement/ad-slots/top-banner-ad-slot/hooks";
import { TargetingPaidType } from "scmp-app/components/advertisement/ad-slots/types";
import { FeedView } from "scmp-app/components/my-news/feed-view";
import { MynewsCard } from "scmp-app/components/my-news/mynews-card";

import { StyledMyDailyFive, StyledMynewsHeader } from "./styles";

export const Mynews: FunctionComponent = () => {
  useTopBannerAdSlot({
    desktop: {
      adUnit: "d_banner1",
      sizes: [[970, 250], [728, 90], [970, 90], "fluid"],
      targeting: {
        paid: TargetingPaidType.Free,
      },
      zone: "mynews/home",
    },
    mobile: {
      adUnit: "m_banner3",
      targeting: {
        paid: TargetingPaidType.Free,
      },
      zone: "mynews/home",
    },
  });

  return (
    <>
      <StyledMynewsHeader isShowIndicatorIcon />
      <StyledMyDailyFive />
      <FeedView />
      <MynewsCard />
    </>
  );
};

Mynews.displayName = "Mynews";
